import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { usePricing } from "../context/PricingContext";

export default function AdminDashboard() {
  const { user, ready, logout } = useAuth();
  const { tiers, setTiers, save, loading } = usePricing();

  if (ready && !user) return <Navigate to="/" replace />; // bounce to Home, no login hint

  function updateTier(i, field, value) {
    const next = tiers.map((t,idx)=> idx===i ? {...t, [field]: value } : t);
    setTiers(next);
  }
  function addTier() {
    setTiers([...tiers, { id: crypto.randomUUID(), name: "New Tier", price: 0, features: [] }]);
  }
  function updateFeature(i, fi, value) {
    const next = [...tiers];
    const features = next[i].features ? [...next[i].features] : [];
    features[fi] = value;
    next[i] = {...next[i], features};
    setTiers(next);
  }
  function addFeature(i) {
    const next = [...tiers];
    next[i] = {...next[i], features: [...(next[i].features||[]), ""]};
    setTiers(next);
  }

  return (
    <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-24">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-extrabold">Admin Dashboard</h1>
        <button onClick={logout} className="px-4 py-2 rounded-lg bg-black text-white">Logout</button>
      </div>

      {loading ? <p className="mt-6">Loading…</p> : (
        <>
          <div className="mt-8 grid gap-6">
            {tiers.map((t,i)=>(
              <div key={t.id} className="rounded-2xl ring-1 ring-black/10 bg-white p-6">
                <div className="grid md:grid-cols-3 gap-4">
                  <input className="border rounded px-3 py-2" value={t.name} onChange={e=>updateTier(i,"name",e.target.value)}/>
                  <input className="border rounded px-3 py-2" type="number" value={t.price} onChange={e=>updateTier(i,"price",Number(e.target.value))}/>
                  <input className="border rounded px-3 py-2" value={t.id} onChange={e=>updateTier(i,"id",e.target.value)}/>
                </div>
                <div className="mt-4">
                  <h4 className="font-semibold mb-2">Features</h4>
                  <div className="grid gap-2">
                    {(t.features||[]).map((f,fi)=>(
                      <input key={fi} className="border rounded px-3 py-2" value={f} onChange={e=>updateFeature(i,fi,e.target.value)}/>
                    ))}
                  </div>
                  <button onClick={()=>addFeature(i)} className="mt-2 text-sm px-3 py-1 rounded bg-brand.blue text-white">+ Add Feature</button>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 flex gap-3">
            <button onClick={addTier} className="px-4 py-2 rounded bg-brand.blue text-white">+ Add Tier</button>
            <button onClick={()=>save(tiers)} className="px-4 py-2 rounded bg-emerald-600 text-white">Save Changes</button>
          </div>
        </>
      )}
    </div>
  );
}
